import { SHAPE_RING, SHAPE_DISC, SHAPE_FRAME, SHAPE_STRIP } from '../constants';
import { ShapeFormConfig } from 'types/index';
import { IntlShape } from 'react-intl';

export const formFields: (intl: IntlShape) => ShapeFormConfig[] = intl => [
  {
    name: SHAPE_RING,
    fields: [
      {
        id: 'outerDiameter',
        name: 'outerDiameter',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.outerDiameter.label',
          defaultMessage: 'Outer diameter',
          description: 'Label for Outer diameter form input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.outerDiameter.placeholder',
          defaultMessage: 'Enter outer diameter value',
          description: 'Placeholder for outer diameter form input',
        }),
        initialValue: '22',
        section: 1,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.outerDiameter.label',
                  defaultMessage: 'Outer diameter',
                  description: 'Label for Outer diameter form input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'innerDiameter',
        name: 'innerDiameter',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.innerDiameter.label',
          defaultMessage: 'Inner diameter',
          description: 'Label for inner diameter input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.innerDiameter.placeholder',
          defaultMessage: 'Enter inner diameter value',
          description: 'Placeholder for inner diameter input',
        }),
        initialValue: '4',
        section: 1,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.innerDiameter.label',
                  defaultMessage: 'Inner diameter',
                  description: 'Label for inner diameter input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'numberOfBoltHoles',
        name: 'numberOfBoltHoles',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.numberOfBoltHoles.label',
          defaultMessage: 'Number of bolt holes',
          description: 'Label for number of boltholes input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.numberOfBoltHoles.placeholder',
          defaultMessage: 'Enter number of bolt holes value',
          description: 'Placeholder for number of boltholes input',
        }),
        initialValue: '0',
        section: 2,
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.innerDiameter.label',
                  defaultMessage: 'Inner diameter',
                  description: 'Label for inner diameter input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
          isOverMaxValue: intl.formatMessage({
            id: 'form.field.error.useMaxValue',
            defaultMessage: 'Maximum value is 100',
            description: 'Validation error for the max value field',
          }),
        },
      },
      {
        id: 'diameterOfBoltHoles',
        name: 'diameterOfBoltHoles',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.diameterOfBoltHoles.label',
          defaultMessage: 'Ø Diameter of bolt holes',
          description: 'Label for diameter of boltholes input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.diameterOfBoltHoles.placeholder',
          defaultMessage: 'Enter diameter of bolt holes value',
          description: 'Placeholder for diameter of boltholes input',
        }),
        initialValue: '0',
        section: 2,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        hideIf: ['numberOfBoltHoles', '0'],
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.diameterOfBoltHoles.label',
                  defaultMessage: 'Ø Diameter of bolt holes',
                  description: 'Label for diameter of boltholes input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'pitchCircle',
        name: 'pitchCircle',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.pitchCircle.label',
          defaultMessage: 'Pitch circle',
          description: 'Label for pitch circle input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.pitchCircle.placeholder',
          defaultMessage: 'Enter pitch circle value',
          description: 'Placeholder for pitch circle input',
        }),
        initialValue: '0',
        section: 2,
        hideIf: ['numberOfBoltHoles', '0'],
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.pitchCircle.label',
                  defaultMessage: 'Pitch circle',
                  description: 'Label for pitch circle input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
    ],
  },
  {
    name: SHAPE_FRAME,
    fields: [
      {
        id: 'outsideLength',
        name: 'outsideLength',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.outsideLength.label',
          defaultMessage: 'Outside length',
          description: 'Label for outside length input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.outsideLength.placeholder',
          defaultMessage: 'Enter outside length value',
          description: 'Placeholder for outside length input',
        }),
        initialValue: '12',
        section: 1,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.outsideLength.label',
                  defaultMessage: 'Outside length',
                  description: 'Label for outside length input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'insideLength',
        name: 'insideLength',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.insideLength.label',
          defaultMessage: 'Inside length',
          description: 'Label for inside length input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.insideLength.placeholder',
          defaultMessage: 'Enter inside length value',
          description: 'Placeholder for inside length input',
        }),
        initialValue: '6',
        section: 1,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.insideLength.label',
                  defaultMessage: 'Inside length',
                  description: 'Label for inside length input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'outsideWidth',
        name: 'outsideWidth',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.outsideWidth.label',
          defaultMessage: 'Outside width',
          description: 'Label for outside width input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.outsideWidth.placeholder',
          defaultMessage: 'Enter outside width value',
          description: 'Placeholder for outside width input',
        }),
        initialValue: '12',
        section: 2,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.outsideWidth.label',
                  defaultMessage: 'Outside width',
                  description: 'Label for outside width input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'insideWidth',
        name: 'insideWidth',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.insideWidth.label',
          defaultMessage: 'Inside width',
          description: 'Label for inside width input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.insideWidth.placeholder',
          defaultMessage: 'Enter inside width value',
          description: 'Placeholder for inside width input',
        }),
        initialValue: '6',
        section: 2,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.insideWidth.label',
                  defaultMessage: 'Inside width',
                  description: 'Label for inside width input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'roundedCorners',
        name: 'roundedCorners',
        label: intl.formatMessage({
          id: 'form.roundedCorners.label',
          defaultMessage: 'Rounded corners',
          description: 'Label for outside radius value',
        }),
        placeholder: intl.formatMessage({
          id: 'form.roundedCorners.placeholder',
          defaultMessage: 'Select rounded corner value',
          description: 'Placeholder for rounded corners select',
        }),
        initialValue: '0',
        section: 3,
        component: 'select',
        options: [
          {
            label: intl.formatMessage({
              id: 'form.roundedCorners.option.no',
              defaultMessage: 'No',
              description: 'Label for rounded corners No',
            }),
            value: '0',
          },
          {
            label: intl.formatMessage({
              id: 'form.roundedCorners.option.yes',
              defaultMessage: 'Yes',
              description: 'Label for rounded corners Yes',
            }),
            value: '1',
          },
        ],
      },
      {
        id: 'outsideRadius',
        name: 'outsideRadius',
        label: intl.formatMessage({
          id: 'form.outsideRadius.label',
          defaultMessage: 'Outer radius',
          description: 'Label for outside radius value',
        }),
        placeholder: intl.formatMessage({
          id: 'form.outsideRadius.placeholder',
          defaultMessage: 'Enter outside radius value',
          description: 'Placeholder for outside radius value',
        }),
        component: 'text',
        initialValue: '0',
        step: '1',
        section: 3,
        hideIf: ['roundedCorners', '0'],
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.outsideRadius.label',
                  defaultMessage: 'Outer radius',
                  description: 'Label for outside radius input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'insideRadius',
        name: 'insideRadius',
        label: intl.formatMessage({
          id: 'form.insideRadius.label',
          defaultMessage: 'Inside radius',
          description: 'Label for inside radius value',
        }),
        placeholder: intl.formatMessage({
          id: 'form.insideRadius.placeholder',
          defaultMessage: 'Enter inside radius value',
          description: 'Placeholder for inside radius value',
        }),
        component: 'text',
        initialValue: '0',
        step: '1',
        section: 3,
        hideIf: ['roundedCorners', '0'],
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.insideRadius.label',
                  defaultMessage: 'Inside radius',
                  description: 'Label for inside radius input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
    ],
  },
  {
    name: SHAPE_DISC,
    fields: [
      {
        id: 'outerDiameter',
        name: 'outerDiameter',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.outerDiameter.label',
          defaultMessage: 'Outer diameter',
          description: 'Label for Outer diameter form input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.outerDiameter.placeholder',
          defaultMessage: 'Enter outer diameter value',
          description: 'Placeholder for outer diameter form input',
        }),
        initialValue: '22',
        section: 1,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.outerDiameter.label',
                  defaultMessage: 'Outer diameter',
                  description: 'Label for Outer diameter form input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'numberOfBoltHoles',
        name: 'numberOfBoltHoles',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.numberOfBoltHoles.label',
          defaultMessage: 'Number of bolt holes',
          description: 'Label for number of boltholes input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.numberOfBoltHoles.placeholder',
          defaultMessage: 'Enter number of bolt holes value',
          description: 'Placeholder for number of boltholes input',
        }),
        initialValue: '0',
        section: 2,
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isWholeNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyWholeNumbers',
            defaultMessage: 'Decimal places are not allowed for this field',
            description: 'Validation error for the no decimal places field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
          isOverMaxValue: intl.formatMessage({
            id: 'form.field.error.useMaxValue',
            defaultMessage: 'Maximum value is 100',
            description: 'Validation error for the max value field',
          }),
        },
      },
      {
        id: 'diameterOfBoltHoles',
        name: 'diameterOfBoltHoles',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.diameterOfBoltHoles.label',
          defaultMessage: 'Ø Diameter of bolt holes',
          description: 'Label for diameter of boltholes input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.diameterOfBoltHoles.placeholder',
          defaultMessage: 'Enter diameter of bolt holes value',
          description: 'Placeholder for diameter of boltholes input',
        }),
        initialValue: '4',
        section: 2,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        hideIf: ['numberOfBoltHoles', '0'],
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.diameterOfBoltHoles.label',
                  defaultMessage: 'Ø Diameter of bolt holes',
                  description: 'Label for diameter of boltholes input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'pitchCircle',
        name: 'pitchCircle',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.pitchCircle.label',
          defaultMessage: 'Pitch circle',
          description: 'Label for pitch circle input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.pitchCircle.placeholder',
          defaultMessage: 'Enter pitch circle value',
          description: 'Placeholder for pitch circle input',
        }),
        initialValue: '0',
        section: 2,
        hideIf: ['numberOfBoltHoles', '0'],
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.pitchCircle.label',
                  defaultMessage: 'Pitch circle',
                  description: 'Label for pitch circle input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
    ],
  },
  {
    name: SHAPE_STRIP,
    fields: [
      {
        id: 'length',
        name: 'length',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.length.label',
          defaultMessage: 'Length',
          description: 'Label for length input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.length.placeholder',
          defaultMessage: 'Length',
          description: 'Placeholder for length input',
        }),
        initialValue: '10',
        section: 1,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required { field }',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.length.label',
                  defaultMessage: 'Length',
                  description: 'Label for length input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
      {
        id: 'width',
        name: 'width',
        component: 'text',
        label: intl.formatMessage({
          id: 'form.width.label',
          defaultMessage: 'Width',
          description: 'Label for width input',
        }),
        placeholder: intl.formatMessage({
          id: 'form.width.placeholder',
          defaultMessage: 'Enter width',
          description: 'Label for width input',
        }),
        initialValue: '4',
        section: 1,
        unitSymbol: 'mm',
        shouldDispatchOnFocus: true,
        validation: {
          isShapeField: true,
          isRequired: intl.formatMessage(
            {
              id: 'form.field.error.required',
              defaultMessage: 'This is a required field',
              description: 'Validation error for the required field',
            },
            {
              field: intl
                .formatMessage({
                  id: 'form.width.label',
                  defaultMessage: 'Width',
                  description: 'Label for width input',
                })
                .toLowerCase(),
            },
          ),
          isNumber: intl.formatMessage({
            id: 'form.field.error.useOnlyNumbers',
            defaultMessage: 'Please use only numerical values',
            description: 'Validation error for the numbers only field',
          }),
          isPositiveNumber: intl.formatMessage({
            id: 'form.field.error.usePositiveNumbers',
            defaultMessage: 'Please use only positive number',
            description: 'Validation error for the positive numbers field',
          }),
        },
      },
    ],
  },
];
